/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArchiveBoxOpenDocsIcon16Regular = forwardRef('ArchiveBoxOpenDocsIcon16Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M5 0a.65.65 0 1 0 0 1.3h6A.65.65 0 1 0 11 0H5Z" }),
        React.createElement("path", { d: "M6.5 8.25a.75.75 0 0 0 0 1.5h3a.75.75 0 1 0 0-1.5h-3Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3.002 3.85c0-.635.515-1.15 1.15-1.15h7.696c.635 0 1.15.515 1.15 1.15V5.5h.252a.75.75 0 0 1 .75.75v5.5A2.25 2.25 0 0 1 11.75 14h-7.5A2.25 2.25 0 0 1 2 11.75v-5.5a.75.75 0 0 1 .75-.75h.252V3.85Zm8.696.15v1.5H4.302V4h7.396ZM3.5 11.75V7h9v4.75a.75.75 0 0 1-.75.75h-7.5a.75.75 0 0 1-.75-.75Z" })));
});
